<template>
  <div class="container">
    <div class="loading">
      <img
        class="pic"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ccfa8281ff6938964bf2cc4b07736aac.png"
        alt=""
      />
      <div class="text">加载中...</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.container {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3000;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .pic {
    width: 56px;
    height: 100px;
    object-fit: contain;
    margin-bottom: 30px;
  }
  .text {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }
  .line-container {
    width: 270px;
    height: 4px;
    background: #eeeeee;
    .percent {
      width: 0%;
      height: 100%;
      overflow: hidden;
      border-radius: 5px;
      .linear-line {
        width: 270px;
        height: 100%;
        background: linear-gradient(
          90deg,
          #ffd9d9 0%,
          #ee5165 14.2%,
          #ff9854 28.4%,
          #ffbd01 42.6%,
          #4cf8b7 56.8%,
          #32cdff 71%,
          #306dff 85.2%,
          #d048ff 100%
        );
      }
    }
  }
}
</style>
